import { render, staticRenderFns } from "./TenantForm.vue?vue&type=template&id=5fb74162&"
import script from "./TenantForm.vue?vue&type=script&lang=js&"
export * from "./TenantForm.vue?vue&type=script&lang=js&"
import style0 from "./TenantForm.vue?vue&type=style&index=0&id=5fb74162&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports